
import * as classNames from "classnames"
import { AddCommentFormRenderProps } from "../../article/componentas/articleComments/addCommentFormWrapper";
import { disablePageRefresh, enablePageRefresh } from "../../../siteWidgets/siteWidgetUtils";
import { getTranslation } from "../../article/componentas/articleComments/translations";


interface AddCommentFormProps {
    props: AddCommentFormRenderProps

}

export class MobileAddCommentFormUIGalhed extends React.Component<AddCommentFormProps, {}> {



    handleInputFocus = () => {
        disablePageRefresh()
    }

    handleInputOutOfFocus = () => {
        enablePageRefresh()
    }

    private handleclosePopUp = () => {
        const { onClosePopUp, handleCloseCommentForm, resetFormData } = this.props.props
        onClosePopUp()
          handleCloseCommentForm()
        resetFormData()
    }

    render() {
        const { isSent, name, comment, isPopUpOpened,
            lang, onInputChanged, handleCommentSend, onClosePopUp, roof, profileImageSrc, soldierName } = this.props.props

        const AddCommentFormClasses = classNames({
            "AddCommentFormGalhed": true,
            "fadeIn": isPopUpOpened,
            "hide": !isPopUpOpened,
        })


        return (
            <div className={AddCommentFormClasses}>
                <div className="PopUpButtonClose" onClick={this.handleclosePopUp}></div>
                <div className="AddCommentForm" >

                    <div className="formTopArea">
                        <img className="profileImage" src={profileImageSrc} alt="Profile Image" />
                        <div className="profileDetails">
                            <div className="soldatRoof">{roof}</div>
                            <div className="soldatTitle">{soldierName}</div>
                        </div>

                    </div>
                    {!isSent &&
                        <>

                            <input
                                className="userDetailsInput inputStyle"
                                maxLength={20}
                                value={name}
                                name="commenterName"
                                placeholder={getTranslation(lang, "Full Name")}
                                onChange={(e) => onInputChanged(e, "name")}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            />

                            <textarea
                                className="comment inputStyle"
                                type="text" maxLength={4000}
                                value={comment}
                                name="commentContent"
                                resize="vertical"
                                placeholder={getTranslation(lang, "Write your dedication")}
                                onChange={(e) => onInputChanged(e, "comment", true)}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            >
                            </textarea>


                            <button className="sendBtn" id="addCommentSendButton" title={getTranslation(lang, "Send your dedication")} onClick={e => handleCommentSend()}>
                                <span>{getTranslation(lang, "Send your dedication")}</span>
                            </button>

                        </>}

                    {isSent && <div className="commentSentMessageWrapper">
                        <div className="thankYouWrapper">

                            <div className="thankYou"><strong >{getTranslation(lang, "Thank you for adding to the memory wall")},</strong> <span>{getTranslation(lang, "Your response has been submitted for approval and will be published subject to the system's considerations.")}</span></div>
                            <button className="sendBtn" title={getTranslation(lang, "Back to soldier page")} onClick={this.handleclosePopUp}>
                                {getTranslation(lang, "Back to soldier page")}
                            </button>
                        </div>
                    </div>}
                </div>

            </div>
        )
    }
}